import { render, staticRenderFns } from "./teacherMicroLesson.vue?vue&type=template&id=67c193eb&scoped=true"
import script from "./teacherMicroLesson.vue?vue&type=script&lang=js"
export * from "./teacherMicroLesson.vue?vue&type=script&lang=js"
import style0 from "./teacherMicroLesson.vue?vue&type=style&index=0&id=67c193eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c193eb",
  null
  
)

export default component.exports